<template lang="pug">
  div(ref="qlToolbar")
    button.btn-reset.ql-bold.ql-btn
      Icon(name="bold" pointer)
    button.btn-reset.ql-italic.ql-btn
      Icon(name="italic" pointer)
    button.btn-reset.ql-underline.ql-btn
      Icon(name="underline" pointer)
    // button.btn-reset.check-list-btn.ql-btn
      Icon(name="check-list")
    button.btn-reset.ql-list.ql-btn(value="bullet")
      Icon(name="list-ul" pointer)
    button.btn-reset.ql-list.ql-btn(value="ordered")
      Icon(name="list-ol" pointer)
    button.btn-reset.ql-blockquote.ql-btn
      Icon(name="blockquote" pointer)
    // button.btn-reset.ql-background.ql-btn
      Icon(name="background")
    button.btn-reset.ql-link.ql-btn
      Icon(name="link" pointer)
    // button.btn-reset.ql-at.ql-btn
      Icon(name="at")
    button.btn-reset.ql-code-block.ql-btn
      Icon(name="code" pointer)
</template>

<script>
export default {
  name: 'WysiwygToolbar',
};
</script>
